import React from "react";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "en", label: "EN" },
  { code: "mr", label: "मर" },
  { code: "hi", label: "हि" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current  = i18n.language;

  return (
    <div style={{
      display: "flex",
      background: "#F3F4F6",
      borderRadius: "8px",
      padding: "2px",
      gap: "1px",
      flexShrink: 0,
    }}>
      {LANGS.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => i18n.changeLanguage(code)}
          style={{
            padding: "4px 9px",
            border: "none",
            borderRadius: "6px",
            fontSize: ".72rem",
            fontWeight: "700",
            cursor: "pointer",
            transition: "background .15s, color .15s",
            background: current === code ? "white" : "transparent",
            color:      current === code ? "#7B1515" : "#9CA3AF",
            boxShadow:  current === code ? "0 1px 3px rgba(0,0,0,.1)" : "none",
            lineHeight: 1.4,
            fontFamily: "inherit",
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
